import type { FC } from 'react';
import { ETemplateType } from '../templates/types';
import { Jobs as JobsDefault } from '../templates/default/containers/jobs';
import { Jobs as JobsVeraAIOperator } from '../templates/vera-operator/containers/jobs';
import { Jobs as JobsVera } from '../templates/vera-admin/containers/jobs';

export const Jobs: FC = () => {
  switch (process.env.REACT_APP_TEMPLATE as ETemplateType) {
    default:
    case ETemplateType.DEFAULT:
      return <JobsDefault />;
    case ETemplateType.EBAY:
    case ETemplateType.VERA_ADMIN:
      return <JobsVera />;
    case ETemplateType.VERA_OPERATOR:
      return <JobsVeraAIOperator />;
  }
};
